import { PATH_URL } from './data/path-url';

export const ICONS = {
  modo: { src: `${PATH_URL}/logos/modo-orange.png`, width: 423, height: 97, defaultHeight: 70 }
} as const;

export type IconName = keyof typeof ICONS;
